export default __webpack_public_path__ + "static/media/img-slider-finedae-2.d051c12c.png";